import '../../general_styles.css';
import './titleform.css';

function Titleform(props) {
    return (
        <div className='titleform__container'>
            <h1 className='titleform__title'>{props.title}</h1>
            <p className='titleform__text'>{props.text}</p>
        </div>
    )
}

export default Titleform;